import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { NavLink, useNavigate } from "react-router-dom";
import "./Header.css";
import {
  faAngleRight,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useContext, useEffect } from "react";
import { Dot_Lottie } from "../common/lotties/dot-lottie/Dot_Lottie";
import { PowerProgress } from "../../utils/apis/homepage";
import { IDS } from "../../utils/common";
import { Context } from "../../utils/context";
import { useLocation, Link } from "react-router-dom";
import { Button, Form } from "react-bootstrap";

const Header = () => {
    const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const { IMG_URL } = useContext(Context);

  const [appsetup, setAppSetup] = useState({});
  const location = useLocation();

  const getAppSetup = async () => {
    const res = await PowerProgress();

    if (res?.success) {
      setAppSetup(res?.data?.[0] || {});
    }
  };

  useEffect(() => {
    getAppSetup();
  }, []);

  return (
    <section className="header_section">
      <div className="container-fluid p-0">
        <Navbar
          expand="lg"
          className="main-navbar"
          collapseOnSelect
          expanded={expanded}
          onToggle={() => setExpanded(!expanded)}
        >
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(expanded ? false : "expanded")}
            className=""
          />

          <Navbar.Brand as={Link} to={"/"} className="mobile_view_logo">
            <div className="logo-wrapper" onClick={() => navigate("/")}>
              <img
                src={IDS?.IMG_URL + appsetup?.logo}
                alt="Ayzair"
                className="top-logo"
              />
            </div>
          </Navbar.Brand>
          <Navbar.Collapse>
            <div className="main-navbar-nav">
              <Navbar.Brand as={Link} to={"/"}  className="desktop_view_logo">
                <div className="logo-wrapper" onClick={() => navigate("/")}>
                  <img
                    src={IDS?.IMG_URL + appsetup?.logo}
                    alt="Ayzair"
                    className="top-logo"
                  />
                </div>
              </Navbar.Brand>

              <Nav className="main-nav-links">
                <Nav.Link
                  as={NavLink}
                  to="/"
                  onClick={() => setExpanded(false)}
                >
                  Home
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to="/explore-produtcs"
                  onClick={() => setExpanded(false)}
                >
                  EXPLORE PRODUCTS
                </Nav.Link>

                <Nav.Link
                  as={NavLink}
                  to="/about-us"
                  onClick={() => setExpanded(false)}
                >
                  About us
                </Nav.Link>
                
                <Nav.Link
                  as={NavLink}
                  to="/blog"
                  onClick={() => setExpanded(false)}
                >
                  Blog
                </Nav.Link>
                
                <Nav.Link
                  as={Link}
                  to="/gallery"
                  onClick={() => setExpanded(false)}
                  className={`nav-link ${
                    location.pathname.startsWith("/gallery") ? "active" : ""
                  }`}
                >
                  Gallery
                </Nav.Link>

                <Nav.Link
                  as={NavLink}
                  to="/contact-us"
                  onClick={() => setExpanded(false)}
                >
                  Contact Us
                </Nav.Link>
                
              </Nav>
            </div>

            <Form className="btn_holder">
              <Button className="get_quote_btn_holder"  onClick={() => navigate("/contact-us")}>
                GET A FREE QUOTE <FontAwesomeIcon icon={faAngleRight} />{" "}
              </Button>
            </Form>
          </Navbar.Collapse>
        </Navbar>
      </div>
    </section>
  );
};

export default Header;
